/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Carrier_Notices_Message_Too_LongInputs */

const en_carrier_notices_message_too_long = /** @type {(inputs: Carrier_Notices_Message_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carrier notice message must be ${i?.max} characters or less.`)
};

const es_carrier_notices_message_too_long = /** @type {(inputs: Carrier_Notices_Message_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El mensaje del aviso debe tener ${i?.max} caracteres o menos.`)
};

/**
* | output |
* | --- |
* | "Carrier notice message must be {max} characters or less." |
*
* @param {Carrier_Notices_Message_Too_LongInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_message_too_long = /** @type {((inputs: Carrier_Notices_Message_Too_LongInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Message_Too_LongInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_message_too_long(inputs)
	return es_carrier_notices_message_too_long(inputs)
});